import * as React from 'react';
import { useSelector } from 'react-redux';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { getWebview } from '@cian/webview/webview';

import { RateApartment } from '../../components/RateApartment';
import { selectDealType, selectDeviceType, selectIsWebview } from '../../selectors/page';

import { EDealType } from '../../types/dealType';
import { useTracking } from './tracking';

const SOURCE_SALE = 'estimation_sale_report_from_ko';
const SOURCE_RENT = 'estimation_rent_report_from_ko';

export function RateApartmentContainer() {
  const isWebview = useSelector(selectIsWebview);
  const deviceType = useSelector(selectDeviceType);
  const dealType = useSelector(selectDealType);

  const { trackRateApartmentClick, trackRateApartmentShow } = useTracking();

  const isSale = dealType === EDealType.Sale;
  const isDesktop = deviceType === 'desktop';

  const source = isSale ? SOURCE_SALE : SOURCE_RENT;

  const onClickHandler = () => {
    trackRateApartmentClick();

    if (isWebview) {
      const webview = getWebview();

      webview.sendAction({
        action: 'open-deeplink',
        payload: {
          url: `https://www.cian.ru/my-home/add-flat`,
        },
      });
    } else {
      window.open(`https://cian.ru/my-home/?isFormOpen=1&from=${source}`, '_blank');
    }
  };

  return (
    <ActionAfterViewObserver callback={trackRateApartmentShow} callbackDelay={0}>
      <RateApartment isSale={isSale} scrollToFilters={onClickHandler} isDesktop={isDesktop} />
    </ActionAfterViewObserver>
  );
}
